import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ViewerControlsPanelComponent } from './viewer-controls-panel/viewer-controls-panel.component'
import { ViewerLayersComponent } from './viewer-controls-panel/viewer-layers/viewer-layers.component'
import { SingleLayerDetailComponent } from './viewer-controls-panel/single-layer-detail/single-layer-detail.component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { FormsModule } from '@angular/forms'
import { LayerGroupComponent } from './viewer-controls-panel/viewer-layers/layer-group/layer-group.component'
import { LetModule } from '@ngrx/component'
import { NeuroglancerFrameComponent } from './neuroglancer-frame/neuroglancer-frame.component'
import { CaseViewerComponent } from './case-viewer.component'
import { SharedModule } from '../shared/shared.module'
import { SelectionModule } from '../selection/selection.module'
import { LayerGroupDetailComponent } from './viewer-controls-panel/layer-group-detail/layer-group-detail.component'
import { ResultsModule } from '../results/results.module'
import { LayerGroupsComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-groups.component'
import { LayerGroupItemComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-group-item/layer-group-item.component'
import { LayerGroupTitleComponent } from './viewer-controls-panel/viewer-layers/layer-groups/layer-group-title/layer-group-title.component'

@NgModule({
    declarations: [
        ViewerControlsPanelComponent,
        ViewerLayersComponent,
        SingleLayerDetailComponent,
        LayerGroupDetailComponent,
        LayerGroupComponent,
        NeuroglancerFrameComponent,
        CaseViewerComponent,
        LayerGroupsComponent,
        LayerGroupItemComponent,
        LayerGroupTitleComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        UiLibraryModule,
        LetModule,
        SharedModule,
        SelectionModule,
        ResultsModule,
    ],
})
export class CaseViewerModule {}
